module.exports = __webpack_public_path__ + "img/team.68d95487.jpg";